import { StickyHeader } from './sticky-header';

const $respMenu = $('.menu--responsive-menu');
	  const $body = $('body');
	  const triggerSelectors = [
		  '.js-menu-toggle',
	  ].join(', ');
	  const $triggers = $(triggerSelectors);

	  $triggers.on('click', () => {
		  $body.toggleClass('menu-open');
		  $triggers.toggleClass('menu-toggle--active');
		});
	$('.js-dash-menu-toggle').on('click', () => {
	$('.menu--dashboard').toggleClass('is-active');
	$('.js-dash-menu-toggle').toggleClass('menu-toggle--active');
	});
	document.addEventListener('DOMContentLoaded', function() {

	});
